import * as React from 'react'

import type { SVGProps } from 'react'

const SvgGelIconChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    stroke="currentColor"
    fill="currentColor"
    strokeWidth={0}
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M21.6 14.3 5.5 31h6.4l14.6-15L11.9 1H5.5l16.1 16.7v-3.4z" stroke="none" />
  </svg>
)

export default SvgGelIconChevronRight
